<template>
  <transition name="slide-down">
    <div class="offline-bar" :class="barClass" v-if="visible">
      <span class="offline-icon">{{ icon }}</span>
      <span class="offline-msg">{{ message }}</span>
      <button class="offline-sync-btn" v-if="queueCount > 0 && isOnline" @click="syncer">
        {{ syncing ? 'Synchro...' : 'Synchroniser' }}
      </button>
    </div>
  </transition>
</template>

<script>
import { getOfflineQueueCount, syncOfflineQueue } from '../api'

export default {
  name: 'OfflineIndicator',
  data() {
    return {
      isOnline:   navigator.onLine,
      queueCount: getOfflineQueueCount(),
      syncing:    false,
      syncResult: null,
      visible:    false
    }
  },
  computed: {
    barClass() {
      if (!this.isOnline)       return 'bar-offline'
      if (this.queueCount > 0)  return 'bar-pending'
      if (this.syncResult)      return 'bar-synced'
      return ''
    },
    icon() {
      if (!this.isOnline)       return '📵'
      if (this.queueCount > 0)  return '⏳'
      if (this.syncResult)      return '✅'
      return ''
    },
    message() {
      if (!this.isOnline) {
        return this.queueCount > 0
          ? `Hors ligne — ${this.queueCount} vente(s) en attente`
          : 'Hors ligne — les ventes seront enregistrées localement'
      }
      if (this.queueCount > 0) {
        return `${this.queueCount} vente(s) à synchroniser`
      }
      if (this.syncResult) {
        return `${this.syncResult.synced} vente(s) synchronisée(s)`
      }
      return ''
    }
  },
  methods: {
    updateVisibility() {
      this.visible = !this.isOnline || this.queueCount > 0 || !!this.syncResult
    },
    async syncer() {
      this.syncing = true
      try {
        const result = await syncOfflineQueue()
        this.syncResult = result
        this.queueCount = getOfflineQueueCount()
        setTimeout(() => {
          this.syncResult = null
          this.updateVisibility()
        }, 3000)
      } finally {
        this.syncing = false
        this.updateVisibility()
      }
    }
  },
  mounted() {
    window.addEventListener('online', () => {
      this.isOnline = true
      this.queueCount = getOfflineQueueCount()
      this.updateVisibility()
    })
    window.addEventListener('offline', () => {
      this.isOnline = false
      this.updateVisibility()
    })
    window.addEventListener('offline-queue-updated', (e) => {
      this.queueCount = e.detail.count
      this.updateVisibility()
    })
    window.addEventListener('offline-sync-done', (e) => {
      this.syncResult = e.detail
      this.queueCount = getOfflineQueueCount()
      setTimeout(() => {
        this.syncResult = null
        this.updateVisibility()
      }, 3000)
    })
    this.updateVisibility()
  }
}
</script>

<style scoped>
.offline-bar {
  position: fixed;
  top: 60px;
  left: 0; right: 0;
  z-index: 90;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.bar-offline  { background: #1a1a1a; color: #ff4444; }
.bar-pending  { background: #744210; color: #fef3c7; }
.bar-synced   { background: #1a4a32; color: #c6f6d5; }

.offline-icon { font-size: 16px; flex-shrink: 0; }
.offline-msg  { flex: 1; }

.offline-sync-btn {
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
  padding: 5px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}
.offline-sync-btn:hover { background: rgba(255,255,255,0.3); }

.slide-down-enter-active, .slide-down-leave-active { transition: all 0.3s ease; }
.slide-down-enter-from, .slide-down-leave-to { transform: translateY(-100%); opacity: 0; }
</style>
